import React, { useEffect } from "react";
import styled from "styled-components";
import Navbar from "../component/Header.js/Navbar/Navbar";
import Footer from "../component/Footer/Footer";
import { Link } from "react-router-dom";

const ExchangePolicy = () => {
    const MainBox = styled.div`
    height: fit-content;
    padding: 4rem 4rem;
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    position: relative;
    @media only screen and (max-width: 1220px) {
      width: 100%;
      padding: 1rem;
    }
  `;

    return (
        <>
            <Navbar />
            <MainBox>
                <h1>RETURN, EXCHANGE & REFUND POLICY</h1>
                <p>
                    At Samriddhi India, we value your trust and strive to provide the finest ethnic wear that blends tradition with modern style. Our goal is to offer you a smooth and satisfying shopping experience.
                </p>
                <p>
                    If you are not happy with your purchase, our easy return and exchange policy ensures you can shop confidently with us.
                </p>

                <h2>1. Exchange & Return Process</h2>
                <ul>
                    <li>Samriddhi India allows a hassle-free exchange and return process for all garments purchased from <a href="https://www.samriddhiindia.in" target="_blank" rel="noopener noreferrer">www.samriddhiindia.in</a> (except Accessories, Perfumes, and Personal Care products).</li>
                    <li><strong>Return Request:</strong> Must be placed within 48 hours of delivery</li>
                    <li><strong>Exchange Request:</strong> Must be placed within 10 days of delivery</li>
                    <li><strong>Partial Returns:</strong> You may request a return for one or more items, but garment sets cannot be separated</li>
                </ul>
                <p>
                    <strong>Important:</strong> Please record an unboxing video while opening your order. This acts as proof in case of refund or damage claims.
                </p>

                <h2>2. Terms & Conditions for Exchange & Return</h2>
                <ul>
                    <li>Products must be unused, unwashed, unaltered, with all tags intact</li>
                    <li>Products with a "No Return" tag are not eligible for exchange or return</li>
                    <li>Exchange is available for products of equal or higher value</li>
                    <li>Accessories & perfumes are non-returnable and non-exchangeable</li>
                </ul>                

                <h2>3. Exchange & Return – In-Store</h2>
                <p>You can exchange or return your order at our exclusive Samriddhi India Store:</p>
                <address>
                    <strong>Samriddhi India</strong><br />
                    Tarun Vihar Lane No. 1, Mothrowala Road,<br />
                    Dehradun, Uttarakhand – 248001<br />
                    <span>Store Contact: 7060187780</span>
                </address>                

                <h2>4. Exchange & Return – Online Orders</h2>
                <ol>
                    <li>Login to <a href="https://www.samriddhiindia.in" target="_blank" rel="noopener noreferrer">www.samriddhiindia.in</a></li>
                    <li>Go to My Orders</li>
                    <li>Select the item and submit an Exchange or Return request</li>
                </ol>
                <p>
                    If your location is serviceable, a free return pick-up will be arranged.
                </p>
                <ul>
                    <li>
                        <strong>If Pickup is Available:</strong>
                        <ul>
                            <li>Keep the product properly packed & unsealed</li>
                            <li>Our pickup team will verify the product on-site</li>
                        </ul>
                    </li>
                    <li>
                        <strong>If Pickup is NOT Available:</strong>
                        <ul>
                            <li>You can self-courier the product to:</li>
                        </ul>
                        <address>
                            <strong>Return Address:</strong><br />
                            Samriddhi India<br />
                            Tarun Vihar Lane No. 1, Mothrowala Road<br />
                            Dehradun, Uttarakhand – 248001
                        </address>
                        <p>
                            For self-shipped returns, we will reimburse up to ₹150 per order for courier charges. Please email the courier receipt to <a href="mailto:care@samriddhiindia.in">care@samriddhiindia.in</a>.
                        </p>
                    </li>
                </ul>

                <h2>5. Refund Policy</h2>
                <ul>
                    <li>Once the returned product passes quality check at our warehouse:</li>
                    <li>Exchanges will be processed, and a replacement product will be shipped</li>
                    <li>Refunds will be credited to the original payment method within 7-10 working days</li>
                </ul>

                <h2>6. Customer Support</h2>
                <p>
                    For queries related to returns, exchanges, or refunds, contact us:
                </p>
                <ul>
                    <li>Email: <a href="mailto:care@samriddhiindia.in">care@samriddhiindia.in</a></li>
                    <li>Toll-Free: +91 95207 82777</li>
                </ul>
                <p>
                    Visit our <Link to="/faqs" target="_blank">FAQs</Link> for more details.
                </p>
            </MainBox>
            <Footer />
        </>
    );
};

export default ExchangePolicy;
